import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvents } from '../services/analytics';
import debounce from 'lodash/debounce';

/**
 * Track navigation events
 */
export function PageAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // Make sure we only track the page once
    const debouncedCall = debounce(() => trackEvents.visit(location.pathname));
    debouncedCall();
    return () => debouncedCall.cancel();
  }, [location.pathname]);

  return null;
}
